import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from "@angular/core";
import { KreFormFieldConfig } from "@kre-form/core";
import * as _ from "lodash";
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { DataService } from "../../service/data.service";

import { ITreeData, ICheckedTree } from "../../tools/util";

@Component({
  selector: "kreform-ds_field-type",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.less"]
})
export class KreFormDSFieldType implements OnInit, OnChanges {
  
  @Output() fieldTypeEvent = new EventEmitter<any>(); 

  fieldTypeList:any=[
    {
      label:"基础类型",
      child:[ 
        {
          type:"radio",
          label:"单 选" 
        },
        {
          type:"checkbox",
          label:"多 选" 
        },
        {
          type:"radiogroup",
          label:"单选组" 
        },
        {
          type:"checkboxgroup",
          label:"多选组" 
        },
        {
          type:"text",
          label:"文本框" 
        }, 
        {
          type:"texti18n",
          label:"多语言"
        },
        {
          type:"select",
          label:"下拉框"
        },
        {
          type:"datetime",
          label:"时间型"
        }
      ]
    },
    {
      label:"高级类型",
      child:[
        {
          type:"image",
          label:"图 片"
        },
        {
          type:"upload",
          label:"附 件"
        },
        {
          type:"group",
          label:"子表单"
        },
        {
          type:"html",
          label:"HTML"
        },
        {
          type:"line",
          label:"分割线"
        }
      ]
    }, 
    {
      label:"特殊类型",
      child:[
        {
          type:"lookup_emp",
          label:"人员列表"
        },
        {
          type:"lookup_org",
          label:"组织列表"
        },
        {
          type:"lookup_position",
          label:"职位信息"
        },
        {
          type:"lookup_area",
          label:"地址信息"
        }
      ]
    }  
  ]
  

  constructor(public dataService: DataService) {}

  ngOnInit() {
    
  }

  ngOnChanges(changes: SimpleChanges) {
     
  }
 
  addFieldType(type:any){
    this.fieldTypeEvent.emit(type);
  }  
}
